import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
@Component({
  selector: 'app-translate-list',
  templateUrl: './translate-list.component.html',
  styleUrls: ['./translate-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TranslateListComponent {
  @Input() list: string[];

  constructor() {}
}
